/* eslint-disable import/prefer-default-export */
export const playerConfig = {
  mediaCoverSizes: [96, 128, 192, 256, 384, 512],
  playNextCounter: 10,
  predefinedPlaybackRates: [0.75, 1, 1.25, 1.5],
  seekBackward: 30,
  seekForward: 15,
  volumeStep: 0.05,
};
